import { computed, makeObservable } from 'mobx'

import { IGroupByOption } from '~/client/src/shared/components/CompactGroupByPicker/CompactGroupByFilter'
import { formsGroupingOptionList } from '~/client/src/shared/enums/LogisticsGroupingOption'
import KnownTranslatorKeys from '~/client/src/shared/localization/knownTranslatorKeys'
import Localization from '~/client/src/shared/localization/LocalizationManager'

export default class MobileLogisticsGroupingOptionsStore {
  public constructor(
    private translatorKeyGetter: (id: string) => KnownTranslatorKeys,
  ) {
    makeObservable(this)
  }

  @computed
  public get groupByOptions(): IGroupByOption[] {
    return formsGroupingOptionList.map(type => ({
      title: Localization.translator[this.translatorKeyGetter(type)],
      groupByType: type,
      shouldRenderSeparator: true,
    }))
  }
}
